import React, { Fragment, useState, useEffect } from "react";
import "leaflet-draw";
import { Box, FormGroup, RadioGroup, Menu, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, Divider, FormControlLabel, Radio } from "@mui/material";
import _ from "lodash";
import { checkLoggedInUserAuthorizedToViewPage, getDecodeURI } from "../../utils/util";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import customPlanIcon from "../../asset/image/CustomPlanIcon.svg";
import starlinkPlanIcon from "../../asset/image/StarlinkPlanIcon.svg";
import orgPoolIcon from "../../asset/image/OrgPoolIcon.svg";
// import { AddCircle } from "@material-ui/icons";
import TuneIcon from "@mui/icons-material/Tune";
import close from "../../asset/image/close.svg";
import "leaflet/dist/leaflet.css";
import "./starlinkPlans.css";
import ArrowCircleDownIcon from '@mui/icons-material/ExpandMore';
import ArrowCircleUpIcon from '@mui/icons-material/ExpandLess';
import CardsContents from "./CardsContents";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { getStarlinkTemplate, getStarlinkPlanHierarchy, getStarlinkPlanTopWidget, clearComponentData, deleteCustomPlanAPI, deleteTemplateAPI, updateStandardPlanAlias, ACTION_TYPES } from "../StarlinkPooled/slice";
import EditActionsPopup from "./EditActionsPopup";
import AssignServiceLine from "./AssignServiceLine";
import EditActionsCreatePlanPopup from "./EditActionsCreatePlanPopup";
// import DeleteIcon from '@mui/icons-material/Delete';
import DeleteIcon from "../../asset/image/deleteEnabled.svg";
import DisabledeleteIcon from "../../asset/image/deleteDisabled.svg";
import starlinkAddNew from "../../asset/image/addSymbol.svg"
import { Edit } from "@mui/icons-material";
import ConfirmDialog from "./ConfirmDeleteDialog";
import EditPlanPopup from "./EditPlanPopup";
import StandardPlanEditPopup from "./StandardPlanEditPopup";
import NewCreatePlanPopup from "./NewCreatePlanPopup";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../config";

const STARLINK_ADMIN_SF = "starlink-admin";
const starlinkAdminService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["service"];
const starlinkAdminFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["function"];


const StarlinkPlans = (props) => {
    const { location, authReducer, getStarlinkTemplate, deleteCustomPlan, deletePlanTemplate, deleteCustomPlanAPI, deleteTemplateAPI, updateStandardPlanAlias, updatingStandardPlanAlias, starlinkPlanTemplate, getStarlinkPlanHierarchy, clearComponentData, starlinkPlanHierarchy, servicePlanTopWidget, getStarlinkPlanTopWidget } = props;
    const dispatch = useDispatch();
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: {},
    });

    const _q = getDecodeURI(location?.search || "");
    const [createPlanDialog, setCreatePlanDialog] = useState<boolean>(false);
    const [anchorElRef, setAnchorElRef] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [isCardExpanded, setIsCardExpanded] = useState(true);
    const [filterPopup, setFilterPopup] = useState(false);
    const [openServiceLineDialog, setOpenServiceLineDialog] = useState(false)
    const [cardContent, setCardContent] = useState<any>([])
    const [openConfirmDeleteTemplate, setOpenConfirmDeleteTemplate] = useState(false)
    const [editPlanDialog, setEditPlanDialog] = useState(false)
    const [currentSubPool, setCurrentSubPool] = useState<any>({
        poolName: '',
        poolSize: '',
        unit: 'tb',
        startDate: null,
        duration: 'monthly',
        isRecurring: true,
        selectedDp: null,
        poolInfo: '',
        assignedBy: '',
        dpId: '',
        data: null,
    });

    const [slClicked, setSlClicked] = useState(null)
    const [expandedRows, setExpandedRows] = useState({});
    const [open, setOpen] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const defaultFilters = [
        { name: "All", label: "all", selected: true },
        { name: "Starlink Only", label: "strOnly", selected: false },
        { name: "Custom Only", label: "cstmOnly", selected: false },
    ];
    const [editStandardPlan, setEditStandardPlan] = useState<any>(false)
    const [selectedFilter, setSelectedFilter] = useState("all");
    const [filter, setFilter] = useState("all")
    const [actionRow, setActionRow] = useState<any>(null)
    const [openConfirmDeletePopup, setOpenConfirmDeletePopup] = useState(false)

    const toggleExpand = () => {
        setIsCardExpanded((prev) => !prev);
    };

    const getPlanFilter = (query) => {
        if (query === 'hierarchy') {
            if (selectedFilter === "strOnly") return "where account_type = 'standard'"
            else if (selectedFilter === "cstmOnly") return "where account_type = 'pooled'"
            else return ""
        } else {
            // if (selectedFilter === "strOnly") return "where plan_type = 'standard'"
            if (selectedFilter === "strOnly") return "where plan_type = 'pool'"
            else if (selectedFilter === "cstmOnly") return "where plan_type = 'pooled'"
            else return "where plan_type = 'pooled'"
        }
    }

    useEffect(() => {
        clearComponentData()
        getStarlinkTemplate({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("template"), search: searchValue })
        getStarlinkPlanHierarchy({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("hierarchy"), search: searchValue })
        getStarlinkPlanTopWidget({ dp_id: authReducer.selectedOu?.id, plan_filter: getPlanFilter("widget") })
    }, [authReducer.selectedOu?.id, selectedFilter, searchValue])

    useEffect(() => {

        if (!_.isEmpty(servicePlanTopWidget)) {
            let cardContent = [
                {
                    heading: "Accounts",
                    leftHeading: "",
                    leftValue: servicePlanTopWidget?.accounts || 0,
                    rightHeading: "",
                    rightValue: "",
                },
                {
                    heading: "Sub Organizations",
                    leftHeading: "",
                    leftValue: servicePlanTopWidget?.total_sub_organizations || 0,
                    rightHeading: "",
                    rightValue: "",
                },
                {
                    heading: "Pools",
                    leftHeading: "",
                    leftValue: servicePlanTopWidget?.pools || 0,
                    rightHeading: "",
                    rightValue: "",
                },
                {
                    heading: "Plans",
                    leftHeading: "Standard",
                    leftValue: servicePlanTopWidget?.standard_plans || 0,
                    rightHeading: "Custom",
                    rightValue: servicePlanTopWidget?.custom_plans || 0,
                },
                {
                    heading: "Service Lines",
                    leftHeading: "Standard",
                    leftValue: servicePlanTopWidget?.standard_service_lines || 0,
                    rightHeading: "Custom",
                    rightValue: servicePlanTopWidget?.custom_service_lines || 0,
                },

            ];
            setCardContent(cardContent);
        }

    }, [servicePlanTopWidget])

    const handleExpandClick = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    useEffect(() => {
        if (slClicked) {
            setOpenServiceLineDialog(true)
        }
    }, [slClicked])

    const truncateText = (text) => {
        if (!text) return '';
        let maxLength = 15;
        if (window.innerWidth > 1700) {
            maxLength = 36;
        }
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };

    const handleDeleteCustomPlan = (row) => {
        if (row?.id) {
            deleteCustomPlanAPI({ customPlanId: row?.id, customPlanName: row?.custom_plan_name })
        }
    }

    const handleDeleteTemplate = (row) => {
        if (row?.id) {
            deleteTemplateAPI({ templateId: row?.id, templateName: row?.custom_plan_name })
        }
    }

    useEffect(() => {
        if (!_.isEmpty(deleteCustomPlan)|| !_.isEmpty(deletePlanTemplate)) {
            getStarlinkPlanHierarchy({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("hierarchy"), search: searchValue })
            getStarlinkTemplate({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("template"), search: searchValue })
            setOpenConfirmDeletePopup(false)
             setOpenConfirmDeleteTemplate(false)
            dispatch({ type: ACTION_TYPES.GET_STARLINK_PLAN_TEMPLATE, payload: { data: [] } })
        }
    }, [deleteCustomPlan, deletePlanTemplate])

    useEffect(() => {
        if (starlinkPlanHierarchy?.length > 0) {
            const expandedMap = {};

            const collectAllUids = (rows) => {
                rows.forEach(row => {
                    expandedMap[row.uid] = true;
                });
            };

            collectAllUids(starlinkPlanHierarchy);
            setExpandedRows(expandedMap);
        }
    }, [starlinkPlanHierarchy]);

    const renderRow = (row, level = 0) => (
        <React.Fragment key={row.id}>
            <TableRow className="strPlan-tableRow">
                <TableCell style={{ paddingLeft: `${level * 20}px`, whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                    {row.children?.length > 0 && row?.children[0] !== null ? (
                        <IconButton size="small" style={{ paddingTop: "0px", paddingBottom: "0px" }} onClick={() => {
                            handleExpandClick(row?.uid)
                        }}>
                            {expandedRows[row.uid] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    ) : <div style={{ width: 25, display: 'inline-block' }} />}
                    <Grid style={{ paddingLeft: `${level * 15}px`, display: "flex", alignItems: 'center' }}>
                        {row?.icon ? <img className="icon-cursor" style={{ paddingRight: "10px" }} src={row?.icon === "CustomPlanIcon" ? customPlanIcon : row?.icon === "orgPoolIcon" ? orgPoolIcon : starlinkPlanIcon} /> : null}
                        <Tooltip title={row?.custom_plan_name || row?.pool_name || row?.plan_name ||row?.account_number + " | " + row?.account_name  || ''}>
                            <span>
                                {row?.account_type ? row?.account_type.charAt(0).toUpperCase() + row?.account_type.slice(1).toLowerCase() + " Account |" : ""} &nbsp;
                                {truncateText(row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || '')}
                            </span>
                        </Tooltip>

                    </Grid>
                </TableCell>
                <TableCell align="center">
                    <Tooltip classes={{ tooltip: 'starlink--tooltip' }}
                        title={
                            <div className="strPlans-tooltip-grid">
                                <Table size="small">
                                    <TableBody>
                                        {row?.organizations?.map((highlight) => {
                                            return (<TableRow>
                                                <TableCell>{highlight?.dp_name}</TableCell>
                                            </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        }>
                        <span>
                            {row?.organizations?.length}  </span>
                    </Tooltip></TableCell>
                <TableCell align="center">{ row?.icon === 'starlinkPlanIcon' || row?.account_type === 'standard' ? "-" :  row?.unit === 'tb' ? row?.size * 1000 : row?.size}</TableCell>
                <TableCell align="center" style={{ color: "blue", cursor: "pointer" }} onClick={() => { if(checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)){ setSlClicked(row) }}} >{row?.total_service_lines || row?.direct_service_lines ? expandedRows[row.uid] ? row?.direct_service_lines : row.total_service_lines : row?.service_lines ? row?.service_lines : 0}</TableCell>

                <TableCell align="right" className="strPlan-table-padding">
                    {(row?.icon === "orgPoolIcon" || row?.account_type === "pooled") &&
                        checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) && (
                            <Tooltip title="Add">
                                <img src={starlinkAddNew} onClick={() => { setOpen(true); setSelectedRow(row) }} className="starlink-add-icon-enabled" />
                            </Tooltip> )}
                    {row?.icon === "CustomPlanIcon" && checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) ?
                        <Tooltip title="Delete">
                            <img src={row?.service_lines !== 0 ? DisabledeleteIcon : DeleteIcon}
                                onClick={(e) => {
                                    if (row?.service_lines === 0) {
                                        setOpenConfirmDeletePopup(true);
                                        setActionRow(row);
                                    } else {
                                        e.preventDefault();
                                    }
                                }}
                                className="starlink-delete-icon-enabled" />
                        </Tooltip> : null}
                </TableCell>
            </TableRow>

            {expandedRows[row?.uid] && row?.children?.length > 0 && (
                row?.children?.map((child) => renderRow(child, level + 1))
            )}
        </React.Fragment>
    );

    interface Account {
        account_number?: string;
        children?: Account[];
        [key: string]: any;
    }

    const filterAccounts = (accounts: Account[]): Account[] => {
        let result: Account[] = [];
        accounts?.forEach(account => {
            const validChildren = account?.children ? filterAccounts(account.children) : [];

            if (account?.account_number === "") {
                result = [...result, ...validChildren];
            }
            else if ((account?.account_number && account?.account_number !== "") || !("account_number" in account)) {
                result.push({ ...account, children: validChildren });
            }
        });
        return result;
    };

    const filteredData: Account[] = filterAccounts(starlinkPlanHierarchy);

    const callPlanHierarchyAPI = () => {
        clearComponentData()
        getStarlinkPlanHierarchy({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("hierarchy"), search: searchValue })
    }

    const callStarlinkTemplateAPI = () => {
          getStarlinkTemplate({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("template"), search: searchValue })
    }

    const handleCloseCreateDialog = () => {
        clearComponentData()
        getStarlinkTemplate({ dpId: authReducer.selectedOu?.id, plan_filter: getPlanFilter("template"), search: searchValue })
        setCreatePlanDialog(false)
        setEditPlanDialog(false)
    }

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
        setFilterPopup(false)
    };

    const filterPopClick = (e: any) => {
        setAnchorElRef(e.currentTarget);
        setFilterPopup(true);
    };

    const handleUpdateStandardPlanAlias = (updatedAlias, originalRow) => {

        let payload = {
            organizationId: originalRow?.dp_id,
            accountNumber: originalRow?.account_number,
            productReferenceId: originalRow?.product_reference_id,
            alias: updatedAlias
        }
        updateStandardPlanAlias(payload)
        setActionRow(null)
        setEditStandardPlan(false)
    } 

    return (
        <div>
            <Grid className="Analytics-Dashboard-Container">
                <Grid container spacing={1} mt={1}>
                   

                    <Grid item md={4} lg={4} className="usage-search-border-color"> </Grid>
                    <Grid item md={4} lg={4} >
                        <div className='filter-search-add-wrapper' style={{marginTop:"0px"}}>
                            <div className="interface-icons-wrapper">
                                {[
                                    { key: "All", subKey: "all" },
                                    { key: "Standard Acct", subKey: "strOnly"},
                                    { key: "Pooled Acct", subKey: "cstmOnly" },
                                ].map(({ key, subKey }) => (
                                    <div
                                        onClick={() => { handleFilterChange(subKey) }}
                                        className={`interface-icon-container ${selectedFilter === subKey ? 'active' : ''}`}
                                    >
                                        {<span className="interface-label" style={{fontSize:"15px"}}>{key}</span>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Grid>
                    <Grid item className="download-expand-icons-container" sx={{ ml: "auto" }}>
                        <div>{isCardExpanded ? <ArrowCircleUpIcon className="starlinkMap-icon" onClick={() => { toggleExpand() }} /> : <ArrowCircleDownIcon className="starlinkMap-icon" onClick={() => { toggleExpand() }} />}</div>
                    </Grid>
                </Grid>

                <Grid style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                    {isCardExpanded && <CardsContents cardContent={cardContent} />}
                </Grid>

                <Grid container spacing={2} style={{ display: "flex", }}>
                    <Grid item xs={6}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "10px" }}>
                            <Typography component="div" className="starlink--base--font_1x">
                              Accounts, Pools, & Plans - Hierarchy
                            </Typography>

                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="starlink--button_contained--primary"
                                    style={{ height: "30px", minWidth: "120px" }}
                                    disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}
                                    onClick={() => { setOpenServiceLineDialog(true) }}
                                >
                                    Bulk Assignment  
                                </Button>
                            </div>
                        </div>

                        <TableContainer component={Paper} className="starlink--table_container strMap-table" style={{ height: "525px" }}>
                            <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell> <span className="font-wt-900">Plan</span></TableCell>
                                        <TableCell>  <span className="font-wt-900">Org</span></TableCell>
                                        <TableCell>  <span className="font-wt-900">Size(GB)</span></TableCell>
                                        <TableCell>  <span className="font-wt-900">Service Lines</span></TableCell>
                                        <TableCell>   <span className="font-wt-900"></span></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData?.length > 0 ? (
                                        filteredData?.map((row) => renderRow(row))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">   No Plans available. </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Grid item xs={6}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "10px" }}>
                            <Typography component="div" className="starlink--base--font_1x">
                                Defined Pools & Plans
                            </Typography>

                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="starlink--button_contained--primary"
                                    style={{ height: "30px", minWidth: "120px" }}
                                    disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}
                                    onClick={() => { setCreatePlanDialog(true) }}
                                >
                                   + New Plan / Pool
                                </Button>
                            </div>
                        </div>

                        <TableContainer component={Paper} className="starlink--table_container strMap-table" style={{ height: "525px" }}>
                            <Table stickyHeader size="small" aria-label="defined-pools-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><span className="font-wt-900"></span></TableCell>
                                        <TableCell><span className="font-wt-900">Name</span></TableCell>
                                        <TableCell><span className="font-wt-900">Type</span></TableCell>
                                        <TableCell><span className="font-wt-900">Size(GB)</span></TableCell>
                                        <TableCell><span className="font-wt-900">Duration</span></TableCell>
                                        {/* <TableCell><span className="font-wt-900">Assignments</span></TableCell> */}
                                          {checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) &&
                                        <TableCell><span className="font-wt-900">Actions</span></TableCell> }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {starlinkPlanTemplate && starlinkPlanTemplate?.length > 0 ? (
                                        starlinkPlanTemplate?.map((pool: any) => (
                                            <TableRow key={pool.id}>
                                                <TableCell><img className="icon-cursor" src={pool?.type === "customPlan" ? customPlanIcon : pool?.type === "orgPool" ? orgPoolIcon : starlinkPlanIcon} title={pool?.type === "customPlan" ? "Custom Plan" : pool?.type === "orgPool" ? "Org Pool" : "Starlink Plan"} /></TableCell>
                                                <TableCell style={{ maxWidth: 150, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={pool.plan_name}>
                                                    {pool.plan_name}
                                                </TableCell>
                                                <TableCell>{pool?.type?.replace(/([A-Z])/g, " $1").replace(/^./, s => s.toUpperCase()).trim()}</TableCell>
                                                <TableCell>{pool.plan_size_gb}</TableCell>
                                                <TableCell>{pool?.duration ? pool?.duration?.charAt(0).toUpperCase() + pool?.duration?.slice(1).toLowerCase() : "-"}</TableCell>
                                                {/* <TableCell>{pool.assignments}</TableCell> */}
                                                {checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) &&
                                                <TableCell> 
                                                   
                                                    <div style={{ display: "flex" }}>
                                                        <Tooltip title="Edit">
                                                            <IconButton 
                                                                 disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}
                                                            size="small" onClick={() => { if(pool?.type === 'customPlan' || pool?.type === 'orgPool') { setEditPlanDialog(true); setActionRow(pool) } else { setEditStandardPlan(true); setActionRow(pool);  } }}>
                                                                <Edit fontSize="small" style={{ color: !checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) ? 'gray' : '#264C86' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        {(pool?.type === 'customPlan' || pool?.type === 'orgPool') &&
                                                            <Tooltip title="Delete">
                                                                <img src={pool?.assignments !== 0 || !checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) ? DisabledeleteIcon : DeleteIcon} 
                                                                    onClick={(e) => {
                                                                        if (pool?.assignments === 0 || checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)) {
                                                                            setOpenConfirmDeleteTemplate(true);
                                                                            setActionRow(pool);
                                                                        } else {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                 className="starlink-delete-icon-enabled" />
                                                            </Tooltip>}
                                                    </div> 
                                                </TableCell> }
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">No templates available.</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>

            <ConfirmDialog open={openConfirmDeleteTemplate} onClose={() => { setOpenConfirmDeleteTemplate(false); setActionRow(null); }} onConfirm={() => handleDeleteTemplate(actionRow)} title="Delete Template" message={`Do you want to delete Template ID "${actionRow?.plan_name}"?`} />
            <EditActionsPopup open={open} selectedPlan={selectedRow} setOpen={setOpen} setConfirmDialog={setConfirmDialog} confirmDialog={confirmDialog} callPlanHierarchyAPI={callPlanHierarchyAPI} starlinkPlanTemplate={starlinkPlanTemplate} handleCloseCreateDialog={handleCloseCreateDialog} />
            <AssignServiceLine open={openServiceLineDialog} setOpen={setOpenServiceLineDialog} slClicked={slClicked} setSlClicked={setSlClicked} planData={filteredData} callPlanHierarchyAPI={callPlanHierarchyAPI} callStarlinkTemplateAPI={callStarlinkTemplateAPI} />
            <ConfirmDialog open={openConfirmDeletePopup} onClose={() => { setOpenConfirmDeletePopup(false); setActionRow(null); }} onConfirm={() => handleDeleteCustomPlan(actionRow)} title="Delete Plan" message={`Do you want to delete "${actionRow?.custom_plan_name}" plan?`} />
             <StandardPlanEditPopup open={editStandardPlan} updatingStandardPlanAlias={updatingStandardPlanAlias} onClose={() => { setEditStandardPlan(false); setActionRow(null); }}   onConfirm={(updatedAlias, originalRow) => { handleUpdateStandardPlanAlias(updatedAlias, originalRow)}} title="Update Plan Alias" message={actionRow} />
            <NewCreatePlanPopup open={createPlanDialog || editPlanDialog} setOpen={handleCloseCreateDialog} callPlanHierarchyAPI={callPlanHierarchyAPI} setEditRow={setActionRow} editRow={editPlanDialog ? actionRow : null} />
        </div>
    );
};

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud?.dpIds || [],
    warnings: state.starlinkDashboard?.warnings || [],
    createPlanTemplate: state.starlinkPooled.createPlanTemplate,
    starlinkPlanTemplate: state.starlinkPooled.starlinkPlanTemplate,
    starlinkPlanHierarchy: state.starlinkPooled.starlinkPlanHierarchy,
    servicePlanTopWidget: state.starlinkPooled.servicePlanTopWidget,
    deleteCustomPlan: state.starlinkPooled.deleteCustomPlan,
     deletePlanTemplate: state.starlinkPooled.deletePlanTemplate,
     updatingStandardPlanAlias: state?.starlinkPooled?.updatingStandardPlanAlias
});

export default withRouter(connect(mapStateToProps, {
    getStarlinkTemplate,
    getStarlinkPlanHierarchy,
    getStarlinkPlanTopWidget,
    clearComponentData,
    deleteCustomPlanAPI,
    deleteTemplateAPI,
    updateStandardPlanAlias
})(StarlinkPlans));
